/**
 * Navigation system exports
 * Centralized exports for the navigation system
 */

// Core types and definitions
export * from './menus';

// Services
export * from './navigationService';

// Re-export permission types that are commonly used with navigation
export { UserRole, getUserRoleFromString } from '../permissions/roles';
